export default __webpack_public_path__ + "static/media/US_AS_Stockist-logo.8c162e20.jpg";